import { ChakraProvider, ColorModeProvider } from '@chakra-ui/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Provider } from 'jotai'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { I18nextProvider } from 'react-i18next'
import { RouterProvider } from 'react-router'
import { ElectronUpdaterProvider } from '~/providers/ElectronUpdaterContext'
import { Sentry } from '~/services/sentry'
import { defaultTheme } from '~/themes/defaultTheme'
import { isProductionBuildEnvironment } from '~/utils/common'

import { i18nConfig } from './i18n.config'
import { router } from './router'

const queryClient = new QueryClient()

function App() {
  const { i18n } = useTranslation()
  useEffect(() => {
    i18n.changeLanguage(window.navigator.language)
  }, [])
  return (
    <ChakraProvider theme={defaultTheme}>
      <ColorModeProvider>
        <Provider>
          <RouterProvider router={router} />
        </Provider>
        {!isProductionBuildEnvironment && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </ColorModeProvider>
    </ChakraProvider>
  )
}

export default function AppWrapper() {
  return (
    <Sentry.ErrorBoundary>
      <I18nextProvider i18n={i18nConfig} defaultNS={'translation'}>
        <QueryClientProvider client={queryClient}>
          <ElectronUpdaterProvider>
            <App />
          </ElectronUpdaterProvider>
        </QueryClientProvider>
      </I18nextProvider>
    </Sentry.ErrorBoundary>
  )
}
